/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getSession = /* GraphQL */ `
  query GetSession($id: ID!) {
    getSession(id: $id) {
      id
      questions
      initTime
      subquestionsOrder
      weCount
      createdAt
      updatedAt
    }
  }
`;
export const listSessions = /* GraphQL */ `
  query ListSessions(
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        questions
        initTime
        subquestionsOrder
        weCount
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getNetworkQualityLog = /* GraphQL */ `
  query GetNetworkQualityLog($id: ID!) {
    getNetworkQualityLog(id: $id) {
      timestamp
      username
      sessionId
      description
      createdAt
      updatedAt
      id
    }
  }
`;
export const listNetworkQualityLogs = /* GraphQL */ `
  query ListNetworkQualityLogs(
    $filter: ModelNetworkQualityLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNetworkQualityLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        timestamp
        username
        sessionId
        description
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const getInterview = /* GraphQL */ `
  query GetInterview($id: ID!) {
    getInterview(id: $id) {
      id
      group
      questions
      interviewInfo
      scheduling
      stage
      companyID
      companyName
      interviewResultData
      questionResponses {
        nextToken
      }
      recordings {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listInterviews = /* GraphQL */ `
  query ListInterviews(
    $filter: ModelInterviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInterviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        questions
        interviewInfo
        scheduling
        stage
        companyID
        companyName
        interviewResultData
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const searchInterviews = /* GraphQL */ `
  query SearchInterviews(
    $filter: SearchableInterviewFilterInput
    $sort: [SearchableInterviewSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableInterviewAggregationInput]
  ) {
    searchInterviews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        group
        questions
        interviewInfo
        scheduling
        stage
        companyID
        companyName
        interviewResultData
        createdAt
        updatedAt
      }
      nextToken
      total
      aggregateItems {
        name
      }
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      group
      email
      firstName
      lastName
      company
      users {
        nextToken
      }
      roles {
        nextToken
      }
      interviews {
        nextToken
      }
      interviewInfo
      discovery
      values1
      values2
      plan
      stripeCustomerId
      status
      hasLoggedIn
      displayOrder
      interviewBuilderData
      createdAt
      updatedAt
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        email
        firstName
        lastName
        company
        interviewInfo
        discovery
        values1
        values2
        plan
        stripeCustomerId
        status
        hasLoggedIn
        displayOrder
        interviewBuilderData
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompanyExamples = /* GraphQL */ `
  query GetCompanyExamples($id: ID!) {
    getCompanyExamples(id: $id) {
      id
      companyID
      attributeId
      score
      text
      createdAt
      updatedAt
    }
  }
`;
export const listCompanyExamples = /* GraphQL */ `
  query ListCompanyExamples(
    $filter: ModelCompanyExamplesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanyExamples(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        attributeId
        score
        text
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompanyInterviewDefaults = /* GraphQL */ `
  query GetCompanyInterviewDefaults($id: ID!) {
    getCompanyInterviewDefaults(id: $id) {
      id
      companyId
      email
      name
      stage
      userId
      createdAt
      updatedAt
    }
  }
`;
export const listCompanyInterviewDefaults = /* GraphQL */ `
  query ListCompanyInterviewDefaults(
    $filter: ModelCompanyInterviewDefaultsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanyInterviewDefaults(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        email
        name
        stage
        userId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getClientAndIndustry = /* GraphQL */ `
  query GetClientAndIndustry($id: ID!) {
    getClientAndIndustry(id: $id) {
      id
      name
      createdAt
      updatedAt
    }
  }
`;
export const listClientAndIndustries = /* GraphQL */ `
  query ListClientAndIndustries(
    $filter: ModelClientAndIndustryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClientAndIndustries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCompanyValues = /* GraphQL */ `
  query GetCompanyValues($id: ID!) {
    getCompanyValues(id: $id) {
      id
      companyID
      title
      description
      weight
      weightedAttributes
      createdAt
      updatedAt
    }
  }
`;
export const listCompanyValues = /* GraphQL */ `
  query ListCompanyValues(
    $filter: ModelCompanyValuesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanyValues(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        title
        description
        weight
        weightedAttributes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSubscriptionProduct = /* GraphQL */ `
  query GetSubscriptionProduct($id: ID!) {
    getSubscriptionProduct(id: $id) {
      id
      product_id
      cost
      currency
      interval
      intervalCount
      metaDescription
      metaLabel
      price_id
      taxBehavior
      createdAt
      updatedAt
    }
  }
`;
export const listSubscriptionProducts = /* GraphQL */ `
  query ListSubscriptionProducts(
    $filter: ModelSubscriptionProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubscriptionProducts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        product_id
        cost
        currency
        interval
        intervalCount
        metaDescription
        metaLabel
        price_id
        taxBehavior
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAttribute = /* GraphQL */ `
  query GetAttribute($id: ID!) {
    getAttribute(id: $id) {
      id
      companyID
      group
      title
      description
      weight
      questions {
        nextToken
      }
      examples {
        text
        score
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAttributes = /* GraphQL */ `
  query ListAttributes(
    $filter: ModelAttributeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttributes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getValue = /* GraphQL */ `
  query GetValue($id: ID!) {
    getValue(id: $id) {
      id
      group
      name
      description
      organizationID
      companyId
      behaviors {
        nextToken
      }
      weight
      status
      createdAt
      updatedAt
    }
  }
`;
export const listValues = /* GraphQL */ `
  query ListValues(
    $filter: ModelValueFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listValues(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        name
        description
        organizationID
        companyId
        weight
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getValueAttribute = /* GraphQL */ `
  query GetValueAttribute($id: ID!) {
    getValueAttribute(id: $id) {
      id
      attributeId
      valueId
      value {
        id
        group
        name
        description
        organizationID
        companyId
        weight
        status
        createdAt
        updatedAt
      }
      companyId
      group
      attribute {
        id
        name
        definition
        stage
        customerDefinition
        align
        nonAlign
        createdAt
        updatedAt
      }
      weight
      order
      createdAt
      updatedAt
    }
  }
`;
export const listValueAttributes = /* GraphQL */ `
  query ListValueAttributes(
    $filter: ModelValueAttributeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listValueAttributes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        attributeId
        valueId
        companyId
        group
        weight
        order
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      group
      name
      isPublished
      companyID
      organizationData
      values {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        name
        isPublished
        companyID
        organizationData
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      group
      firstName
      lastName
      title
      companyID
      email
      phone
      status
      role
      hasLoggedIn
      lastLoggedIn
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        firstName
        lastName
        title
        companyID
        email
        phone
        status
        role
        hasLoggedIn
        lastLoggedIn
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRole = /* GraphQL */ `
  query GetRole($id: ID!) {
    getRole(id: $id) {
      id
      group
      name
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const listRoles = /* GraphQL */ `
  query ListRoles(
    $filter: ModelRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        name
        workingSession
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getJobRole = /* GraphQL */ `
  query GetJobRole($id: ID!) {
    getJobRole(id: $id) {
      id
      group
      status
      jobRoleData
      exercise
      emailTemplate
      workingSession
      companyID
      createdAt
      updatedAt
    }
  }
`;
export const listJobRoles = /* GraphQL */ `
  query ListJobRoles(
    $filter: ModelJobRoleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobRoles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        group
        status
        jobRoleData
        exercise
        emailTemplate
        workingSession
        companyID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReview = /* GraphQL */ `
  query GetReview($id: ID!) {
    getReview(id: $id) {
      id
      interviewId
      author
      notes
      createdAt
      updatedAt
    }
  }
`;
export const listReviews = /* GraphQL */ `
  query ListReviews(
    $filter: ModelReviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReviews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        interviewId
        author
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getQuestionResponse = /* GraphQL */ `
  query GetQuestionResponse($id: ID!) {
    getQuestionResponse(id: $id) {
      id
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      subquestionResponses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listQuestionResponses = /* GraphQL */ `
  query ListQuestionResponses(
    $filter: ModelQuestionResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionResponses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        interviewId
        stage
        rating
        timestamp
        interviewerName
        question
        notes
        order
        attribute
        attributeResolved
        ai_score
        ai_reasoning
        ai_quotes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAiQuestionResponseArchive = /* GraphQL */ `
  query GetAiQuestionResponseArchive($id: ID!) {
    getAIQuestionResponseArchive(id: $id) {
      id
      original_id
      rick_score
      interviewId
      stage
      rating
      timestamp
      interviewerName
      question
      notes
      order
      attribute
      attributeResolved
      ai_score
      ai_reasoning
      ai_quotes
      createdAt
      updatedAt
    }
  }
`;
export const listAiQuestionResponseArchives = /* GraphQL */ `
  query ListAiQuestionResponseArchives(
    $filter: ModelAIQuestionResponseArchiveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAIQuestionResponseArchives(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        original_id
        rick_score
        interviewId
        stage
        rating
        timestamp
        interviewerName
        question
        notes
        order
        attribute
        attributeResolved
        ai_score
        ai_reasoning
        ai_quotes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSubquestionResponse = /* GraphQL */ `
  query GetSubquestionResponse($id: ID!) {
    getSubquestionResponse(id: $id) {
      id
      questionResponseId
      question
      notes
      order
      displayTime
      createdAt
      updatedAt
    }
  }
`;
export const listSubquestionResponses = /* GraphQL */ `
  query ListSubquestionResponses(
    $filter: ModelSubquestionResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubquestionResponses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        questionResponseId
        question
        notes
        order
        displayTime
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRecording = /* GraphQL */ `
  query GetRecording($id: ID!) {
    getRecording(id: $id) {
      id
      interviewId
      stage
      path
      createdAt
      updatedAt
    }
  }
`;
export const listRecordings = /* GraphQL */ `
  query ListRecordings(
    $filter: ModelRecordingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecordings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        interviewId
        stage
        path
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getMeeting = /* GraphQL */ `
  query GetMeeting($id: ID!) {
    getMeeting(id: $id) {
      id
      interviewId
      stage
      startTime
      endTime
      audioUrl
      files {
        interviewerTranscriptUrl
        interviewerAudioUrl
        intervieweeTranscriptUrl
        intervieweeAudioUrl
      }
      analysis {
        id
        timestamp
        ml_version
        createdAt
        updatedAt
      }
      ai_conclusion_next_stage
      ai_conclusion_reasoning
      ai_conclusion_fit
      ai_conclusion_strong
      ai_conclusion_weak
      ai_agg_score
      ai_confidence
      createdAt
      updatedAt
      meetingAnalysisId
    }
  }
`;
export const listMeetings = /* GraphQL */ `
  query ListMeetings(
    $filter: ModelMeetingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMeetings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        interviewId
        stage
        startTime
        endTime
        audioUrl
        ai_conclusion_next_stage
        ai_conclusion_reasoning
        ai_conclusion_fit
        ai_conclusion_strong
        ai_conclusion_weak
        ai_agg_score
        ai_confidence
        createdAt
        updatedAt
        meetingAnalysisId
      }
      nextToken
    }
  }
`;
export const getQuestion = /* GraphQL */ `
  query GetQuestion($id: ID!) {
    getQuestion(id: $id) {
      id
      stage
      companyID
      attributes {
        nextToken
      }
      isActive
      text
      interactionType
      order
      required
      createdAt
      updatedAt
      isPrivate
    }
  }
`;
export const listQuestions = /* GraphQL */ `
  query ListQuestions(
    $filter: ModelQuestionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      nextToken
    }
  }
`;
export const getCompanyQuestions = /* GraphQL */ `
  query GetCompanyQuestions($id: ID!) {
    getCompanyQuestions(id: $id) {
      companyID
      questions {
        nextToken
      }
      createdAt
      updatedAt
      id
    }
  }
`;
export const listCompanyQuestions = /* GraphQL */ `
  query ListCompanyQuestions(
    $filter: ModelCompanyQuestionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanyQuestions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        companyID
        createdAt
        updatedAt
        id
      }
      nextToken
    }
  }
`;
export const getSubQuestions = /* GraphQL */ `
  query GetSubQuestions($id: ID!) {
    getSubQuestions(id: $id) {
      id
      questionID
      isActive
      text
      createdAt
      updatedAt
    }
  }
`;
export const listSubQuestions = /* GraphQL */ `
  query ListSubQuestions(
    $filter: ModelSubQuestionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubQuestions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        questionID
        isActive
        text
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAnalysis = /* GraphQL */ `
  query GetAnalysis($id: ID!) {
    getAnalysis(id: $id) {
      id
      timestamp
      ml_version
      attributeAnalyses {
        nextToken
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAnalyses = /* GraphQL */ `
  query ListAnalyses(
    $filter: ModelAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAnalyses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        timestamp
        ml_version
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getAttributeAnalysis = /* GraphQL */ `
  query GetAttributeAnalysis($id: ID!) {
    getAttributeAnalysis(id: $id) {
      id
      isLatest
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      questionAnalyses {
        nextToken
      }
      createdAt
      updatedAt
      analysisAttributeAnalysesId
      attributeAnalysisAttributeId
    }
  }
`;
export const listAttributeAnalyses = /* GraphQL */ `
  query ListAttributeAnalyses(
    $filter: ModelAttributeAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttributeAnalyses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isLatest
        createdAt
        updatedAt
        analysisAttributeAnalysesId
        attributeAnalysisAttributeId
      }
      nextToken
    }
  }
`;
export const getAttributeDefinitions = /* GraphQL */ `
  query GetAttributeDefinitions($id: ID!) {
    getAttributeDefinitions(id: $id) {
      id
      name
      definition
      stage
      customerDefinition
      align
      nonAlign
      createdAt
      updatedAt
    }
  }
`;
export const listAttributeDefinitions = /* GraphQL */ `
  query ListAttributeDefinitions(
    $filter: ModelAttributeDefinitionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttributeDefinitions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        definition
        stage
        customerDefinition
        align
        nonAlign
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getQuestionAttributeAnalysis = /* GraphQL */ `
  query GetQuestionAttributeAnalysis($id: ID!) {
    getQuestionAttributeAnalysis(id: $id) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      attributeAnalysisQuestionAnalysesId
      questionAttributeAnalysisQuestionId
    }
  }
`;
export const listQuestionAttributeAnalyses = /* GraphQL */ `
  query ListQuestionAttributeAnalyses(
    $filter: ModelQuestionAttributeAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionAttributeAnalyses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        score
        reasoning
        createdAt
        updatedAt
        id
        attributeAnalysisQuestionAnalysesId
        questionAttributeAnalysisQuestionId
      }
      nextToken
    }
  }
`;
export const getQuestionDiscoveryAnalysis = /* GraphQL */ `
  query GetQuestionDiscoveryAnalysis($id: ID!) {
    getQuestionDiscoveryAnalysis(id: $id) {
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      score
      reasoning
      quotes {
        start
        end
        sentence
      }
      createdAt
      updatedAt
      id
      analysisQuestionAnalysesId
      questionDiscoveryAnalysisQuestionId
    }
  }
`;
export const listQuestionDiscoveryAnalyses = /* GraphQL */ `
  query ListQuestionDiscoveryAnalyses(
    $filter: ModelQuestionDiscoveryAnalysisFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionDiscoveryAnalyses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        score
        reasoning
        createdAt
        updatedAt
        id
        analysisQuestionAnalysesId
        questionDiscoveryAnalysisQuestionId
      }
      nextToken
    }
  }
`;
export const getWorkingSessionExercise = /* GraphQL */ `
  query GetWorkingSessionExercise($id: ID!) {
    getWorkingSessionExercise(id: $id) {
      id
      role {
        id
        group
        name
        workingSession
        companyID
        createdAt
        updatedAt
      }
      companyId
      exercise
      question1
      question2
      question3
      question4
      question5
      createdAt
      updatedAt
      workingSessionExerciseRoleId
    }
  }
`;
export const listWorkingSessionExercises = /* GraphQL */ `
  query ListWorkingSessionExercises(
    $filter: ModelWorkingSessionExerciseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkingSessionExercises(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        exercise
        question1
        question2
        question3
        question4
        question5
        createdAt
        updatedAt
        workingSessionExerciseRoleId
      }
      nextToken
    }
  }
`;
export const getAttributeQuestions = /* GraphQL */ `
  query GetAttributeQuestions($id: ID!) {
    getAttributeQuestions(id: $id) {
      id
      attributeID
      questionID
      attribute {
        id
        companyID
        group
        title
        description
        weight
        createdAt
        updatedAt
      }
      question {
        id
        stage
        companyID
        isActive
        text
        interactionType
        order
        required
        createdAt
        updatedAt
        isPrivate
      }
      createdAt
      updatedAt
    }
  }
`;
export const listAttributeQuestions = /* GraphQL */ `
  query ListAttributeQuestions(
    $filter: ModelAttributeQuestionsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttributeQuestions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        attributeID
        questionID
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
